/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Info"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let claimValueData = fromData.useDataValue({ viewPath,
context: 'claim',
})
let chargeTemplatesValueData = fromData.useDataValue({ viewPath,
context: 'charge_templates',
})
let patientInsurancePaymentAccountsValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: 'insurance_payment_accounts',
})
let aggregateData = fromHelpers.getView(claimValueData, chargeTemplatesValueData, patientInsurancePaymentAccountsValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}